import { BrandMatch } from "./types";

// Match seguro: igualdade exata, igualdade do primeiro label, ou wildcard '*.base'
// (host === base || host.endsWith('.' + base)). Nunca substring/includes.
export function hostMatches(host: string, patterns?: string[]): boolean {
  if (!host || !patterns?.length) return false;
  const label = host.split(".")[0];

  return patterns.some((p) => {
    // wildcard de domínio: '*.base' casa base e subdomínios.
    if (p.startsWith("*.")) {
      const base = p.slice(2);
      return host === base || host.endsWith("." + base);
    }
    // prefixo de label: 'base*' casa o label 'base' ou 'base-<sufixo>' (ambientes como
    // portalnave-dev, portalnave-dev-local). Exige o hífen — 'portalnavefake' NÃO casa.
    if (p.endsWith("*")) {
      const base = p.slice(0, -1);
      return label === base || label.startsWith(base + "-");
    }
    // label dedicado (sem ponto) casa o primeiro label; senão, host completo.
    return p.includes(".") ? host === p : label === p;
  });
}

// Domínio dedicado da marca (usado pelo resolver e pelo travamento de fluxo).
export function matchesDomain(host: string, match: BrandMatch): boolean {
  return hostMatches(host, match.domains);
}

export function matchesRules(rules: string | undefined, match: BrandMatch): boolean {
  return !!rules && !!match.rules?.includes(rules);
}

export function matchesUrlHost(urlHost: string | undefined, match: BrandMatch): boolean {
  return !!urlHost && hostMatches(urlHost, match.urlHosts);
}
